export enum QuoteStatus {
  STARTED = 'STARTED',
  RATING = 'RATING',
  RATED = 'RATED',
  COMPLETED = 'COMPLETED',
  SOLDFINAL = 'SOLDFINAL',
  DUPLICATING = 'DUPLICATING',
}
